module.exports = __webpack_public_path__ + "static/media/spinner-preloader.0c6f34a3.gif";